import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import useGlynt from './useGlynt';

export default function usePaginatedOrgs(label: string, limit: number = 100) {
  const [page, setPage] = useState(0);
  const glynt = useGlynt();

  // Reset to first page whenever the search label changes.
  useEffect(() => {
    setPage(0);
  }, [label]);

  const { data, isError, isPending, isFetching } = useQuery({
    queryKey: ['orgs', { page, limit, label }],

    queryFn: async () =>
      (await glynt).org.list({
        advanced: true,
        limit,
        offset: page * limit,
        ordering: 'label',
        ...(label ? { ilabel__contains: label } : {}),
      }),

    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData
  });

  const total = data ? Math.ceil(data.count / limit) : 1;

  const nextPage = () => {
    if (page < total - 1) setPage((page) => page + 1);
  };

  const previousPage = () => {
    if (page > 0) setPage((page) => page - 1);
  };

  return {
    data,
    error: isError,
    isPending,
    isLoading: isPending,
    loading: isPending,
    nextPage,
    previousPage,
    total,
    page,
    setPage,
    isFetching,
  };
}
